import type { ReactNode } from 'react';
import { LiksTooltip } from '../LiksTooltip/LiksTooltip';
import './LiksChatMessageGeneratedImage.css';

export type LiksChatMessageImageActionButtonProps = {
  label: string;
  className?: string;
  disabled?: boolean;
  onClick: () => void;
  children: ReactNode;
};

export function LiksChatMessageImageActionButton({
  label,
  className = 'liks-chat-message__image-action',
  disabled = false,
  onClick,
  children,
}: LiksChatMessageImageActionButtonProps) {
  return (
    <LiksTooltip content={label} placement="top-end">
      <button
        type="button"
        className={className}
        aria-label={label}
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </button>
    </LiksTooltip>
  );
}
